export const VEHICLE_STATUSES = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  PULLED: 'pulled',
  AWARDED: 'awarded',
  DEACTIVATED: 'deactivated',
  UNDER_REVIEW: 'under_review'
};

export const ADMIN_VEHICLE_STATUS = {
  ...VEHICLE_STATUSES,
  IN_PROGRESS: 'in_progress',
  SELLER_COUNTER_SENT: 'seller_counter_sent',
  ADMIN_COUNTER_SENT: 'admin_counter_sent',
  BUYER_COUNTER_SENT: 'buyer_counter_sent',
  SELLER_NOT_COUNTERED: 'seller_not_countered',
  SELLER_ACCEPTED: 'seller_accepted',
  UNDECIDED: 'undecided',
  BUYER_NOT_COUNTERED: 'buyer_not_countered',
  PUBLIC_ADMIN_COUNTER_SENT: 'public_admin_counter_sent',
  SELLER_COUNTERED: 'seller_countered',
  ALTERNATIVE_SELLER_COUNTERED: 'alternative_seller_countered',
  NEED_SELLER_REVIEW: 'need_seller_review',
  EXTENSION_TIME: 'extension_time',
  TIME_ENDED: 'time_ended'
};

export const SELLER_VEHICLE_STATUS = {
  ...VEHICLE_STATUSES,
  IN_PROGRESS: 'in_progress',
  COUNTER_SENT_TO_BUYERS: 'counter_sent_to_buyers',
  BUYER_COUNTER_SENT: 'buyer_counter_sent',
  NEED_SELLER_REVIEW: 'need_seller_review',
  PENDING: 'pending',
  PENDING_AUTOAXESS_REVIEW: 'pending_autoaxess_review',
  PENDING_ADMIN_APPROVAL: 'pending_admin_approval',
  ACCEPTED_OFFER_PENDING_ADMIN_APPROVAL: 'accepted_offer_pending_admin_approval',
  PUBLIC_COUNTER_SENT_TO_BUYERS: 'public_counter_sent_to_buyers',
  ADMIN_ACTION_REQUIRED: 'admin_action_required',
  SELLER_ACTION_REQUIRED: 'seller_action_required',
  TIME_ENDED: 'time_ended'
};

export const BUYER_VEHICLE_STATUS = {
  ...VEHICLE_STATUSES,
  DECLINED: 'declined',
  AWARDED_NOT_CHARGED: 'awarded_not_charged',
  AWARDED_PENDING_CHARGE: 'awarded_pending_charge',
  UNDECIDED: 'undecided',
  COUNTERED: 'countered',
  BUYER_COUNTER_SENT: 'buyer_counter_sent',
  OUT_BID: 'out_bid',
  HIGH_BID: 'high_bid',
  SELLER_ACCEPTING_OFFERS: 'seller_accepting_offers',
  TOP_BUYER_SELLER_ACCEPTING_OFFER: 'top_buyer_seller_accepting_offers',
  // TODO: figure out this status
  PENDING_APPROVAL: 'pending_approval',

  ACTIVE_ALTERNATIVE_AUCTION: 'active_alternative_auction',
  ALTERNATIVE_UNDECIDED: 'alternative_undecided',
  ALTERNATIVE_UNDECIDED_WITH_OFFER: 'alternative_undecided_with_offer',
  TIME_ENDED: 'time_ended',
  ADMIN_ACTION_REQUIRED: 'admin_action_required'
};

export const BUYER_VEHICLE_LABELS = {
  [BUYER_VEHICLE_STATUS.DRAFT]: {
    color: '#E47E00',
    label: 'Draft'
  },
  [BUYER_VEHICLE_STATUS.AWARDED]: {
    color: '#06A000',
    label: 'Awarded'
  },
  [BUYER_VEHICLE_STATUS.AWARDED_NOT_CHARGED]: {
    color: '#06A000',
    label: 'Awarded'
  },
  [BUYER_VEHICLE_STATUS.AWARDED_PENDING_CHARGE]: {
    color: '#06A000',
    label: 'Awarded - Pending Charge'
  },
  [BUYER_VEHICLE_STATUS.PULLED]: {
    color: '#D50808',
    label: 'Pulled'
  },
  [BUYER_VEHICLE_STATUS.DECLINED]: {
    color: '#D50808',
    label: 'Declined'
  },
  [BUYER_VEHICLE_STATUS.UNDECIDED]: {
    color: '#E47E00',
    label: 'Undecided'
  },
  [BUYER_VEHICLE_STATUS.PENDING_APPROVAL]: {
    color: '#E47E00',
    label: 'Undecided'
  },
  [BUYER_VEHICLE_STATUS.SELLER_ACCEPTING_OFFERS]: {
    color: '#E47E00',
    label: 'Seller Accepting Offers'
  },
  [BUYER_VEHICLE_STATUS.TOP_BUYER_SELLER_ACCEPTING_OFFER]: {
    color: '#E47E00',
    label: 'Seller Accepting Offers'
  },
  [BUYER_VEHICLE_STATUS.COUNTERED]: {
    color: '#CA8D57',
    label: 'Countered'
  },
  [BUYER_VEHICLE_STATUS.OUT_BID]: {
    color: '#E47E00',
    label: 'OutBid'
  },
  [BUYER_VEHICLE_STATUS.HIGH_BID]: {
    color: '#06A000',
    label: 'Highest Bidder'
  },
  [BUYER_VEHICLE_STATUS.BUYER_COUNTER_SENT]: {
    color: '#CA8D57',
    label: 'Counter Sent to Seller'
  },
  [BUYER_VEHICLE_STATUS.ACTIVE_ALTERNATIVE_AUCTION]: {
    color: '#06A000',
    label: 'Active'
  },
  [BUYER_VEHICLE_STATUS.ALTERNATIVE_UNDECIDED]: {
    color: '#CA8D57',
    label: 'Waiting for seller to accept or counter'
  },
  [BUYER_VEHICLE_STATUS.ALTERNATIVE_UNDECIDED_WITH_OFFER]: {
    color: '#CA8D57',
    label: 'Undecided'
  },
  [BUYER_VEHICLE_STATUS.TIME_ENDED]: {
    color: '#CA8D57',
    label: 'Time Ended'
  },
  [BUYER_VEHICLE_STATUS.ADMIN_ACTION_REQUIRED]: {
    color: '#e47E00',
    label: 'Admin Action Required'
  }
};

export const SELLER_VEHICLE_LABELS = {
  [SELLER_VEHICLE_STATUS.DRAFT]: {
    color: '#E47E00',
    label: 'Draft'
  },
  [SELLER_VEHICLE_STATUS.IN_PROGRESS]: {
    color: '#06A000',
    label: 'Active'
  },
  [SELLER_VEHICLE_STATUS.AWARDED]: {
    color: '#06A000',
    label: 'Awarded'
  },
  [SELLER_VEHICLE_STATUS.COUNTER_SENT_TO_BUYERS]: {
    color: '#E47E00',
    label: 'Counter Sent To Buyer'
  },
  [SELLER_VEHICLE_STATUS.PUBLIC_COUNTER_SENT_TO_BUYERS]: {
    color: '#E47E00',
    label: 'Counter Sent To Buyers'
  },
  [SELLER_VEHICLE_STATUS.PULLED]: {
    color: '#D50808',
    label: 'Pulled'
  },
  [SELLER_VEHICLE_STATUS.NEED_SELLER_REVIEW]: {
    color: '#E47E00',
    label: 'Need Seller Review'
  },
  [SELLER_VEHICLE_STATUS.SELLER_ACTION_REQUIRED]: {
    color: '#E47E00',
    label: 'Seller Action Required'
  },
  [SELLER_VEHICLE_STATUS.PENDING]: {
    color: '#E47E00',
    label: 'Pending'
  },
  [SELLER_VEHICLE_STATUS.PENDING_AUTOAXESS_REVIEW]: {
    color: '#E47E00',
    label: 'Pending Autoaxess Review'
  },
  [SELLER_VEHICLE_STATUS.BUYER_COUNTER_SENT]: {
    color: '#E47E00',
    label: 'Counter Sent to Seller'
  },
  [SELLER_VEHICLE_STATUS.PENDING_ADMIN_APPROVAL]: {
    color: '#e47E00',
    label: 'Pending Admin Approval'
  },
  [SELLER_VEHICLE_STATUS.ACCEPTED_OFFER_PENDING_ADMIN_APPROVAL]: {
    color: '#e47E00',
    label: 'Pending Admin Approval'
  },
  [SELLER_VEHICLE_STATUS.ADMIN_ACTION_REQUIRED]: {
    color: '#e47E00',
    label: 'Admin Action Required'
  },
  [SELLER_VEHICLE_STATUS.TIME_ENDED]: {
    color: '#e47E00',
    label: 'Time Ended'
  }
};

export const ADMIN_VEHICLE_LABELS = {
  [SELLER_VEHICLE_STATUS.DRAFT]: {
    color: '#E47E00',
    label: 'Draft'
  },
  [ADMIN_VEHICLE_STATUS.ACTIVE]: {
    color: '#06A000',
    label: 'Active'
  },
  [ADMIN_VEHICLE_STATUS.IN_PROGRESS]: {
    color: '#06A000',
    label: 'Active'
  },
  [ADMIN_VEHICLE_STATUS.AWARDED]: {
    color: '#06A000',
    label: 'Awarded'
  },
  [ADMIN_VEHICLE_STATUS.PULLED]: {
    color: '#D50808',
    label: 'Pulled'
  },
  [ADMIN_VEHICLE_STATUS.DEACTIVATED]: {
    color: '#D50808',
    label: 'Deactivated'
  },
  [ADMIN_VEHICLE_STATUS.UNDER_REVIEW]: {
    color: '#D50808',
    label: 'Under Review'
  },
  [ADMIN_VEHICLE_STATUS.SELLER_COUNTER_SENT]: {
    label: 'Seller Counter Sent to Buyer'
  },
  [ADMIN_VEHICLE_STATUS.UNDECIDED]: {
    label: 'Undecided'
  },
  [ADMIN_VEHICLE_STATUS.ADMIN_COUNTER_SENT]: {
    label: 'AutoAxess Counter Sent to Buyer'
  },
  [ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT]: {
    label: 'Counter Sent to Seller'
  },
  [ADMIN_VEHICLE_STATUS.BUYER_NOT_COUNTERED]: {
    label: 'Buyer didn’t Counter'
  },
  [ADMIN_VEHICLE_STATUS.SELLER_NOT_COUNTERED]: {
    label: 'Seller didn’t Counter'
  },
  [ADMIN_VEHICLE_STATUS.PUBLIC_ADMIN_COUNTER_SENT]: {
    label: 'AutoAxess Counter Sent to Buyers'
  },
  [ADMIN_VEHICLE_STATUS.SELLER_ACCEPTED]: {
    label: 'Seller Accepted'
  },
  [ADMIN_VEHICLE_STATUS.SELLER_COUNTERED]: {
    label: 'Seller Countered'
  }
};
